import { useState } from 'preact/hooks'
import { ComponentChildren } from 'preact'
import Icon from '$store/components/ui/Icon.tsx'

function IframeModal({
    children,
    iframeUrl,
}: {
    children: ComponentChildren
    iframeUrl: string
}) {
    const [iframeOpen, setiframeOpen] = useState(false)

    return (
        <>
            <button
                class='cursor-pointer absolute -bottom-1 left-[52px] font-lato'
                onClick={() => {
                    setiframeOpen(!iframeOpen)
                }}
            >
                {children}
            </button>
            {iframeOpen && (
                <div className='modal modal-open cursor-pointer bg-black rounded-md bg-opacity-50 font-lato'>
                    <div className='modal-box relative bg-white rounded-lg border-2 border-primary-700 p-0 w-full max-w-4xl mx-3 h-full max-h-[740px]'>
                        <iframe
                            class='h-full w-full'
                            src={iframeUrl}
                            title='Fale conosco'
                        />
                        <button
                            class='p-2 absolute top-2 right-2 cursor-pointer'
                            onClick={() => {
                                setiframeOpen(!iframeOpen)
                            }}
                        >
                            <Icon class='text-primary' id='XMark' height={20} width={20} />
                        </button>
                    </div>
                </div>
            )}
            {
                /*
			<input type='checkbox' id='my-modal-4' className='modal-toggle' />
			<label
				htmlFor='my-modal-4'
				className='modal cursor-pointer bg-black rounded-md bg-opacity-50 font-lato'
			>
				<label
					className='modal-box relative bg-white rounded-lg border-2 border-primary-700 p-0 w-full max-w-4xl mx-3 h-full max-h-[740px]'
					htmlFor=''
				>
					<iframe class='h-full w-full' src={iframeUrl} title='Fale conosco' />
					<label for='my-modal-4' class='p-2 absolute top-2 right-2 cursor-pointer'>
						<Icon class='text-primary' id='XMark' height={20} width={20} />
					</label>
				</label>
			</label> */
            }
        </>
    )
}

export default IframeModal
